export const seller = {
  // index
  seller: {
    zh: '销售商',
    en: '',
    pu: 'Sellers'
  },
  sellerName: {
    zh: '销售商姓名',
    en: '',
    pu: 'Nome do Seller'
  },
  sellerNamePlaceholder: {
    zh: '搜索销售商姓名',
    en: '',
    pu: 'Pesquise pelo nome do seller'
  },
  sellerCode: {
    zh: '销售商代码',
    en: '',
    pu: 'Código do seller'
  },
  sellerCodePlaceholder: {
    zh: '搜索销售商代码',
    en: '',
    pu: 'Pesquise pelo código do seller'
  },
  driverStatus: {
    zh: '司机状态',
    en: '',
    pu: 'Status motoristas'
  },
  driverStatusPlaceholder: {
    zh: '选择销售商状态',
    en: '',
    pu: 'Selecione o status do seller'
  },
  registeredSellers: {
    zh: '已注册销售商',
    en: '',
    pu: 'Sellers cadastrados'
  },
  unregisteredSellers: {
    zh: '未注册销售商',
    en: '',
    pu: 'Sellers não cadastrados'
  },

  // tableDataRegistered
  client: {
    zh: '客户',
    en: '',
    pu: 'Cliente'
  },
  cep: {
    zh: '邮政编码',
    en: '',
    pu: 'CEP'
  },
  address: {
    zh: '地址',
    en: '',
    pu: 'Endereço'
  },

  // actionsTableDataRegistered
  edit: {
    zh: '编辑',
    en: '',
    pu: 'Editar'
  },
  delete: {
    zh: '删除',
    en: '',
    pu: 'Excluir'
  },
  editTitle: {
    zh: '编辑销售商',
    en: '',
    pu: 'Editando Seller'
  },
  editParagraph: {
    zh: '填写下面的字段以编辑我们系统中的销售商',
    en: '',
    pu: 'Preencha os campos logo abaixo para realizar a edição de um seller em nosso sistema'
  },
  deleteTitle: {
    zh: '您确定吗？',
    en: '',
    pu: 'Você tem certeza absoluta?'
  },
  deleteParagraph: {
    zh: '此操作无法撤销。这将禁用销售商及其所有相关操作。',
    en: '',
    pu: 'Essa ação não pode ser desfeita. Isso ira desativar o seller e todas as operações relacionados a esses dados'
  },
  buttonCancel: {
    zh: '取消',
    en: '',
    pu: 'Cancelar'
  },
  buttonDelete: {
    zh: '是的，我想要删除',
    en: '',
    pu: 'Sim, quero excluir'
  },

  // actionsTableDataNotRegistered
  create: {
    zh: '创建',
    en: '',
    pu: 'Criar'
  },
  createTitle: {
    zh: '创建销售商',
    en: '',
    pu: 'Criando Seller'
  },
  createParagraph: {
    zh: '填写下面的字段以在我们系统中创建销售商',
    en: '',
    pu: 'Preencha os campos logo abaixo para realizar a criação de um seller em nosso sistema'
  },

  // formDataSeller
  phone: {
    zh: '电话',
    en: '',
    pu: 'Telefone'
  },
  phonePlaceholder: {
    zh: '输入销售商的电话',
    en: '',
    pu: 'Digite o telefone do seller'
  },
  email: {
    zh: '电子邮件',
    en: '',
    pu: 'Email'
  },
  emailPlaceholder: {
    zh: '输入销售商的邮箱',
    en: '',
    pu: 'Digite o email do seller'
  },
  document: {
    zh: '个人/法人税号',
    en: '',
    pu: 'Documento'
  },
  documentPlaceholder: {
    zh: '输入CNPJ或CPF号码',
    en: '',
    pu: 'Digite o número do CNPJ ou CPF'
  },
  nameContact: {
    zh: '联系人姓名',
    en: '',
    pu: 'Nome do Contato'
  },
  nameContactPlaceholder: {
    zh: '输入联系人姓名',
    en: '',
    pu: 'Digite o nome do contato'
  },
  state: {
    zh: '州',
    en: '',
    pu: 'Estado'
  },
  outsourced: {
    zh: '外包',
    en: '',
    pu: 'Terceirizado'
  },
  a: {
    zh: '',
    en: '',
    pu: ''
  },
  identityInfo: {
    zh: '身份信息',
    en: 'Identity Information',
    pu: 'Informações de identidade'
  },
  fileUpload: {
    zh: '文件上传',
    en: 'File Upload',
    pu: 'Upload de arquivos'
  },
  addressInfo: {
    zh: '地址信息',
    en: 'Address Information',
    pu: 'informações de endereço'
  },
  bankInfo: {
    zh: '银行信息',
    en: 'Bank Information',
    pu: 'Informações bancárias'
  },
  driverInfo: {
    zh: '司机信息',
    en: 'Driver Information',
    pu: 'Informações do banco'
  },
  documentInfo: {
    zh: '证件信息',
    en: 'Document Information',
    pu: 'Informações da carteira de habilitação'
  },
  vehicleInfo: {
    zh: '车辆信息',
    en: 'Vehicle Information',
    pu: 'Informações do veículo'
  },
  ownerInfo: {
    zh: '车主信息',
    en: 'Owner Information',
    pu: 'Informações do proprietário'
  },
  expirationTime: {
    zh: '失效时间',
    en: 'Expiration Time',
    pu: 'Tempo de expiração'
  },
  documentReviewTime: {
    zh: '资料提交审核时间',
    en: 'Document Submission Review Time',
    pu: 'Tempo de Revisão de Submissão de Documentos'
  },
  expired: {
    zh: '已失效',
    en: 'Expired',
    pu: 'Expirado'
  },
  informationDetails: {
    zh: '信息明细',
    en: 'Information Details',
    pu: 'Detalhes da Informação'
  },
  invitationCodeInfo: {
    zh: '邀请码信息',
    en: 'Invitation Code Information',
    pu: 'Informação do Código de Convite'
  },
  cnpjNumber: {
    zh: 'CNPJ号码',
    en: 'CNPJ Number',
    pu: 'Número CNPJ'
  },
  anttRntrc: {
    zh: 'ANTT-RNTRC',
    en: 'ANTT-RNTRC',
    pu: 'ANTT-RNTRC'
  },
  fileImages: {
    zh: '文件图片',
    en: 'File Images',
    pu: 'Imagens de Arquivo'
  },
  districtNeighborhood: {
    zh: '区/邻里',
    en: 'District/Neighborhood',
    pu: 'Bairro/Vizinhança'
  },
  bankName: {
    zh: '银行名称',
    en: 'Bank Name',
    pu: 'Nome do Banco'
  },
  agent: {
    zh: '代理',
    en: 'Agent',
    pu: 'Agente'
  },
  buildingNumber: {
    zh: '楼栋号',
    en: 'Building Number',
    pu: 'Número do Prédio'
  },
  ownerMotherFullName: {
    zh: '车主母亲全名',
    en: "Owner's Mother Full Name",
    pu: 'Nome Completo da Mãe do Proprietário'
  },
  ownerFatherFullName: {
    zh: '车主父亲全名',
    en: "Owner's Father Full Name",
    pu: 'Nome Completo do Pai do Proprietário'
  },
  ownerIdIssueState: {
    zh: '车主身份证颁发州',
    en: "Owner's ID Issuing State",
    pu: 'Estado Emissor do Documento do Proprietário'
  },
  ownerCpf: {
    zh: '车主CPF',
    en: "Owner's CPF",
    pu: 'CPF do Proprietário'
  },
  ownerFullName: {
    zh: '车主全名',
    en: "Owner's Full Name",
    pu: 'Nome Completo do Proprietário'
  },
  vehicleOwner: {
    zh: '车辆拥有者',
    en: 'Vehicle Owner',
    pu: 'Proprietário do Veículo'
  },
  licensePlateState: {
    zh: '车牌所属州',
    en: 'License Plate State',
    pu: 'Estado da Placa'
  },
  licensePlateRegistrationCity: {
    zh: '车牌登记城市',
    en: 'License Plate Registration City',
    pu: 'Cidade de Registro da Placa'
  },
  vehicleRegistrationNumber: {
    zh: '车辆登记号',
    en: 'Vehicle Registration Number',
    pu: 'Número de Registro do Veículo'
  },
  vehicleColor: {
    zh: '车辆颜色',
    en: 'Vehicle Color',
    pu: 'Cor do Veículo'
  },
  process: {
    zh: '处理',
    en: 'Process',
    pu: 'Processar'
  },
  processingMethod: {
    zh: '处理方式',
    en: 'Processing Method',
    pu: 'Método de Processamento'
  },
  deliveryPrice: {
    zh: '派送价格',
    en: 'Delivery Price',
    pu: 'Preço de Entrega'
  },
  addInvitationCode: {
    zh: '新增邀请码',
    en: 'Add Invitation Code',
    pu: 'Adicionar Código de Convite'
  },
  resubmit: {
    zh: '重新提交',
    en: 'Resubmit',
    pu: 'Reenviar'
  },
  rejectRegistration: {
    zh: '拒绝注册',
    en: 'Reject Registration',
    pu: 'Rejeitar Registro'
  },
  selectSubmittedInfo: {
    zh: '选择提交的信息',
    en: 'Select Submitted Information',
    pu: 'Selecionar Informação Enviada'
  },
  message: {
    zh: '留言',
    en: 'Message',
    pu: 'Mensagem'
  },
  driverFullName: {
    zh: '司机全名',
    en: "Driver's Full Name",
    pu: 'Nome Completo do Motorista'
  },
  rgNumber: {
    zh: 'RG号码',
    en: 'RG Number',
    pu: 'Número do RG'
  },
  idIssuingState: {
    zh: '身份颁发州',
    en: 'ID Issuing State',
    pu: 'Estado Emissor do Documento'
  },
  dateOfBirth: {
    zh: '出生日期',
    en: 'Date of Birth',
    pu: 'Data de Nascimento'
  },
  fatherName: {
    zh: '父亲姓名',
    en: "Father's Name",
    pu: 'Nome do Pai'
  },
  motherName: {
    zh: '母亲姓名',
    en: "Mother's Name",
    pu: 'Nome da Mãe'
  },
  maritalStatus: {
    zh: '婚姻状态',
    en: 'Marital Status',
    pu: 'Estado Civil'
  },
  driverLicenseNumber: {
    zh: '驾驶证号码',
    en: "Driver's License Number",
    pu: 'Número da CNH'
  },
  licenseFirstIssueDate: {
    zh: '证件首次颁发日期',
    en: 'License First Issue Date',
    pu: 'Data da Primeira Emissão da CNH'
  },
  expiryDate: {
    zh: '到期日期',
    en: 'Expiry Date',
    pu: 'Data de Validade'
  },
  licenseIssuingState: {
    zh: '驾驶证颁发州',
    en: 'License Issuing State',
    pu: 'Estado Emissor da CNH'
  },
  licenseType: {
    zh: '驾驶证类型',
    en: 'License Type',
    pu: 'Tipo de CNH'
  },
  securityCode: {
    zh: '安全码',
    en: 'Security Code',
    pu: 'Código de Segurança'
  },
  licensePlateNumber: {
    zh: '车牌号',
    en: 'License Plate Number',
    pu: 'Número da Placa'
  },
  vinNumber: {
    zh: '车架号',
    en: 'VIN Number',
    pu: 'Número do Chassi'
  },
  vehicleBody: {
    zh: '车身',
    en: 'Vehicle Body',
    pu: 'Carroceria'
  },
  vehicleManufactureYear: {
    zh: '车辆制造年份',
    en: 'Vehicle Manufacture Year',
    pu: 'Ano de Fabricação do Veículo'
  },
  vehicleModelYear: {
    zh: '车辆型号年份',
    en: 'Vehicle Model Year',
    pu: 'Ano do Modelo do Veículo'
  },
  invitationCode: {
    zh: '邀请码',
    en: 'Invitation Code',
    pu: 'Código de Convite'
  },
  CPFNumber: {
    zh: 'CPF号码',
    en: 'CNPJ Number',
    pu: 'Número CPF'
  },
  customTableDisplayList: {
    zh: '自定义表格显示列表',
    en: 'Custom Table Display List',
    pu: 'Lista de Exibição de Tabela Personalizada'
  },
  downloadWaybill: {
    zh: '下载面单',
    en: 'Download Waybill',
    pu: 'Baixar etiqueta'
  },
  auditRejectionReason: {
    zh: '审核不通过原因',
    en: 'Audit Rejection Reason',
    pu: 'Motivo de Rejeição na Auditoria'
  },
  selectedConditions: {
    zh: '已选条件',
    en: 'Selected Conditions',
    pu: 'Filtros selecionados'
  },
  clearAll: {
    zh: '清空全部',
    en: 'Clear All',
    pu: 'Limpar Tudo'
  }
};
